export default __webpack_public_path__ + "assets/hero-large.04fb9732.jpg";